import { Box, Button, Heading, Text, VStack } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import { t } from "i18next";
import { RiShieldKeyholeLine } from "react-icons/ri";

export const UnAuthorizedAccess = () => {
  const navigate = useNavigate();

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      minH="80vh"
      textAlign="center"
      px={4}
    >
      <VStack spacing={6} maxW="md" mx="auto">
        <Box as={RiShieldKeyholeLine} size="64px" color="gray.400" mb={4} />

        <Heading as="h1" size="xl" fontWeight="bold">
          {t("unauthorized.title", "Access Denied")}
        </Heading>

        <Text fontSize="lg" color="gray.600">
          {t(
            "unauthorized.message",
            "You don't have permission to access this page.",
          )}
        </Text>

        <Button mt={6} onClick={() => navigate(-1)} size="lg">
          {t("buttons.go_back", "Go Back")}
        </Button>

        <Button
          variant="outline"
          onClick={() => navigate("/dashboard")}
          size="lg"
        >
          {t("buttons.go_to_dashboard", "Go to Dashboard")}
        </Button>
      </VStack>
    </Box>
  );
};
